<div class="profile-container">
  <div class="">
    <div class="profile-content">
      <!-- <div class="personal-details">
        <h4 class="personal-details-title">Offer List</h4>
        <table class="table table-striped">
          <thead>
            <tr>
              <th scope="col">#</th>
              <th scope="col">Name</th>
              <th scope="col">Description</th>
              <th scope="col">Action</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let offer of OfferData | paginate : {
              itemsPerPage: tableSize,
              currentPage: page,
              totalItems: count};let i = index">
              <th scope="col">{{offer.offersId}}</th>
              <th scope="col">{{offer.name}}</th>
              <th scope="col">{{offer.description}}</th>
              <th scope="col">
                <svg xmlns="http://www.w3.org/2000/svg" data-toggle="modal" (click)="getOfferById(offer.offersId,offer.name)" data-target="#view" width="18" height="18" fill="currentColor" class="bi bi-eye-fill" viewBox="0 0 16 16">
                    <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z"/>
                    <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8zm8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z"/>
                </svg> 
            </th>
            </tr>
          </tbody>
        </table>
        <div class="pagination-block" *ngIf="OfferData.length != 0">
          <pagination-controls
            previousLabel="Prev"
            nextLabel="Next"
            (pageChange)="onTableDataChange($event)"
          >
          </pagination-controls>
        </div>
      </div> -->


      <div class="personal-details">
          
        <div class="header-block">
            <div class="header-title">
                <p>Offer List</p>
            </div>
            <div class="add-block">
                <div class="search">
                    <form autocomplete="off" >
                        <input type="text" placeholder="search">
                    </form>
                    <i class="bi bi-search" ></i>
                </div>
                <button *ngIf="actionControls.isAdd" data-toggle="modal" data-target="#addModal"><i class="bi bi-plus-lg"></i> Add</button>
            </div>
        </div>

        <table class="table table-striped">
            <thead>
                <tr>
                <th style="width: 20%;">#</th>
                <th style="width: 30%;">Name</th>
                <th style="width: 30%;">Description</th>
                <th style="width: 20%;text-align: center;padding: 0;" class="">Action</th>
                </tr>
            </thead>
        </table>
        <div *ngIf="!isLoading">
          <div class="data-view" *ngFor="let offer of OfferData | paginate : {
            itemsPerPage: tableSize,
            currentPage: page,
            totalItems: count};let i = index">

                <p style="width: 20%;">{{offer.offersId}}</p>
                <p style="width: 30%;">{{offer.name}}</p>
                <p style="width: 30%;">{{offer.description}}</p>
                <p class="action-buttons" style="width: 20%;padding-left: 25px;">
                  <i *ngIf="actionControls.isModify" class="bi bi-pencil-square" (click)="getOfferById1(offer.offersId)" data-toggle="modal" data-target="#updateModal" ></i>
                  <i *ngIf="actionControls.isView" class="bi bi-eye-fill" data-toggle="modal" (click)="getOfferById(offer.offersId,offer.name)" data-target="#view"></i>
                  <i *ngIf="actionControls.isDelete" class="bi bi-trash" (click)="del(offer.id)" data-toggle="modal" data-target="#deleteModal"></i>
                </p>
            </div>
        </div>


        <div class="loader" *ngIf="isLoading">
            <div class="spinner"></div>
        </div>

        <div class="loader"  *ngIf="!isLoading && OfferData.length == 0">
            <div class="no-data">
                <img src="assets/no-data-6.png" alt="">
                <p>no data found</p>
            </div>
            
        </div>

        <div class="paginator">
            <p-paginator (onPageChange)="onTableDataChange($event)" [first]="first" [rows]="tableSize" [totalRecords]="count"
            [showFirstLastIcon]="false" [showCurrentPageReport]="true" currentPageReportTemplate="{first} - {last} of {totalRecords}">
            </p-paginator>
        </div>


    </div>
    </div>
  </div>
</div>

<div class="modal fade" id="view" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Offer Details 
          <span data-dismiss="modal">
            <i data-dismiss="modal" class="bi bi-x-lg"></i>
          </span>
        </h5>
      </div>
      <div class="modal-body">
        <div class="form-group" *ngFor="let offer of singleOfferData">
          <div class="row">
            <div class="col-md-12 col-lg-12">
              <label>Offer Name</label>
              <input type="text" value="{{offer.name}}" class="form-control">
            </div>
            <div class="col-md-12 col-lg-12">
              <label>Offer Description</label>
              <textarea name="" value="{{offer.description}}" class="form-control" id="" cols="30" rows="5"></textarea>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" id="" class="btn btn-primary" data-toggle="modal" data-target="#offerModal">Send Offer</button>
          <button type="button" id="closeModalButton2" class="btn btn-secondary" data-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>
</div>


<div class="modal fade" id="offerModal" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header" style="padding: 5px;">
        <h5 class="modal-title count" id="exampleModalLabel">{{offerName}} <span>Count: {{userSelectCount}}</span></h5>
      </div>
      <div class="modal-body" style="padding-top: 0;">
        <div  class="row user-types-block">
          <div class="col-md-6 col-lg-6 user-type" [ngClass]="{'user-type-selected' : usersType == 'Marketing users'}">
            <p (click)="changeUserType('Marketing users')">Marketing users</p>
          </div>
          <!-- <div class="col-md-4 col-lg-4 user-type" [ngClass]="{'user-type-selected' : usersType == 'users'}">
            <p (click)="changeUserType('users')"> users</p>
          </div> -->
          <div class="col-md-6 col-lg-6 user-type" [ngClass]="{'user-type-selected' : usersType == 'Customer users'}">
            <p (click)="changeUserType('Customer users')">Customer users</p>
          </div>
        </div>
  
     
        <div class="typeUsers" *ngIf="usersType == 'Marketing users'">
          <div class="row" *ngFor="let param of paramList;let i = index;let last = last">
            <div class="col-md-5 col-lg-5">
              <select name="" id="" class="form-control" (change)="paramSelect($event,i)">
                <option value="" selected disabled>select</option>
                <option [value]="param.id" *ngFor="let param of params">{{param.name}}</option>
              </select>
            </div>
            <div class="col-md-6 col-lg-6">
              <select name="" id="" class="form-control" [(ngModel)]="paramList[i].possibleValueSelected">
                <option value="" selected disabled>select</option>
                <option [value]="val" *ngFor="let val of paramList[i].possibleValue">{{val}}</option>
              </select>
            </div>
            <div class="col-md-1 col-lg-1 p-buttons">
              <i *ngIf="last" (click)="addParam()" class="bi bi-plus-circle"></i>
              <i *ngIf="!last"(click)="removeParam(i)" class="bi bi-dash-circle"></i>
            </div>
          </div>
          <button class="btn btn-secondary"(click)="getMarketingDataByKeyAndValue()">get</button>
          <button class="btn btn-secondary"(click)="getMarketingData()">get all</button>
          <div class="whatsapp-block">
            <hr>
            <div class="userList-block row">
              <div class="col-lg-4 col-sm-4 col-md-4" *ngFor="let user of marketingDataUser;let i = index">
                <div class="single-userlist" [ngClass]="{'bc' : user.isChecked}">
                  <input type="checkbox" (click)="selectMarketingUser(i,$event)" [checked]="user.isChecked">
                  <div>
                    <p>{{user.name}}</p>
                    <p>{{user.email}}</p>
                    <p>{{user.mobileNo1}}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="typeUsers" *ngIf="usersType == 'Customer users'">
          <div class="row" *ngFor="let param of customerParamList;let i = index;let last = last">
            <div class="col-md-5 col-lg-5">
              <select name="" id="" class="form-control" (change)="customerParamSelect($event,i)">
                <option value="" selected disabled>select</option>
                <option [value]="param.id" *ngFor="let param of params">{{param.name}}</option>
              </select>
            </div>
            <div class="col-md-6 col-lg-6">
              <select name="" id="" class="form-control" [(ngModel)]="customerParamList[i].possibleValueSelected">
                <option value="" selected disabled>select</option>
                <option [value]="val" *ngFor="let val of customerParamList[i].possibleValue">{{val}}</option>
              </select>
            </div>
            <div class="col-md-1 col-lg-1 p-buttons">
              <i *ngIf="last" (click)="addCustomerParam()" class="bi bi-plus-circle"></i>
              <i *ngIf="!last"(click)="removeCustomerParam(i)" class="bi bi-dash-circle"></i>
            </div>
          </div>
          <button class="btn btn-secondary"(click)="getCustomersByKeyAndValue()">get</button>
          <button class="btn btn-secondary"(click)="getAllCustomers()">get all</button>
          <div class="whatsapp-block">
            <hr>
            <div class="userList-block row">
              <div class="col-lg-4 col-sm-4 col-md-4" *ngFor="let customer of customersList;let i = index">
                <div class="single-userlist" [ngClass]="{'bc' : customer.isChecked}">
                  <input type="checkbox" (click)="customerSelected(i,$event)" [checked]="customer.isChecked">
                  <div>
                    <p>{{customer.name}}</p>
                    <p>{{customer.emailId}}</p>
                    <p>{{customer.mobileNo1}}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <div class="select-send-type">
            <div class="select-send-options">
              <div>
                <input type="radio" name="opt">
              <label for="">SMS</label>
              </div>
              <div>
                <input type="radio" name="opt">
                <label for="">EMail</label>
              </div>
              <div>
                <input type="radio" name="opt">
                <label for="">Whatsapp</label>
              </div>
              <div>
                <input type="radio" name="opt">
                <label for="">Push Notifications</label>
              </div>
            </div>
          
            <div>
              <button type="button" id="closeWhatsappModel" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
              <button type="button" class="btn btn-primary" (click)="sendOffer()">Send</button>
            </div>
          </div>
         
        </div>
      </div>
    </div>
  </div>
</div>


<div class="modal fade" id="deleteModal" tabindex="-1" data-backdrop="static" aria-labelledby="deleteModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
      <div class="modal-header">
          <h5 class="modal-title" id="deleteModalLabel">Confirmation!! 
            <span data-dismiss="modal">
              <i data-dismiss="modal" class="bi bi-x-lg"></i>
            </span>
          </h5>
      </div>
      <div class="modal-body">
          <p>are you sure? want to delete??</p>   
      <div class="modal-footer">
          <button type="button" id="closeModalButton1" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
          <button type="button" class="btn btn-primary" (click)="deleteOffer()">Delete</button>
      </div>
      </div>
  </div>
  </div>
</div>




<div class="modal fade" id="addModal" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Add Offer
          <span data-dismiss="modal">
            <i data-dismiss="modal" class="bi bi-x-lg"></i>
          </span>
        </h5>
      </div>
      <div class="modal-body">
        <div [formGroup]="form">
          <div class="row">
            <div class="col-md-12 col-lg-12">
              <div class="form-group">
                <label>Name <span class="required-field">*</span></label>
                <input formControlName="name" type="text" class="form-control">
                <span class="err" *ngIf="form.get('name').invalid && formSubmitted">name required</span>
              </div>
            </div>
            <div class="col-md-12 col-lg-12">
              <div class="form-group">
                <label>Description <span class="required-field">*</span></label>
                <textarea class="form-control" formControlName="description" name="" id="" cols="30" rows="10"></textarea>
                <span class="err" *ngIf="form.get('description').invalid && formSubmitted">description required</span>
              </div>
            </div>
          </div>
        </div>  
          <div class="modal-footer">
              <button type="button" id="closeAdd" class="btn btn-secondary" data-dismiss="modal">Cancel</button>

              <button type="button" (click)="addOffer()" class="btn btn-primary">Submit</button>
          </div>
      </div>
    </div>
  </div>
</div>


<div class="modal fade" id="updateModal" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Update Offer
          <span data-dismiss="modal">
            <svg data-dismiss="modal" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
              <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
            </svg>
          </span>
        </h5>
      </div>
      <div class="modal-body">
        <div [formGroup]="editForm">
          <div class="row">
            <div class="col-md-12 col-lg-12">
              <div class="form-group">
                <label>Name <span class="required-field">*</span></label>
                <input formControlName="name" type="text" class="form-control">
                <span class="err" *ngIf="editForm.get('name').invalid && editFormSubmitted">name required</span>
              </div>
            </div>
            <div class="col-md-12 col-lg-12">
              <div class="form-group">
                <label>Description <span class="required-field">*</span></label>
                <textarea class="form-control" formControlName="description" name="" id="" cols="30" rows="10"></textarea>
                <span class="err" *ngIf="editForm.get('description').invalid && editFormSubmitted">description required</span>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" id="closeModalButton"  class="btn btn-secondary" data-dismiss="modal">Cancel</button>
          <button type="button" (click)="updateOffer()" class="btn btn-primary">save changes</button>
        </div>
      </div>
    </div>
  </div>
</div>